import axiosInstance from "@helper/interceptor";

export const getProductionSensors = async () => {
  const response = await axiosInstance.get("internal/sensors/production-dashboard/");
  return response.data;
};
